const feedbackOptions = [
  'I am receiving too many emails.',
  'I am not the correct person to contact.',
  'The content is not relevant to our site.',
  'We only share information from government agencies or non-for profits.',
  'Your emails are spam.',
];

export default feedbackOptions;
